import React from "react";
import { Outlet } from "react-router-dom";

const BayHirePage: React.FC = () => {
  return (
    <div data-testid="bay-hire">
      <Outlet />
    </div>
  );
};

export default BayHirePage;
